'use client';
import React, {useEffect, useLayoutEffect, useMemo, useRef, useState} from 'react';
import { Choice, SelectionData } from '../questions';
import { FormLabel, TextField } from '@mui/material';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import ClientComponent from '@/components/builder/client_component';

const FileUpload: React.FC<SelectionData> = ({setSelectedAnswer, choices, editData, ...props}) => {  

    const [selectedValue, setSelectedValue] = React.useState();

    const radioInputRef = useRef<HTMLInputElement>(null);


  
    const handleRadioChange = (event:any) => {
      const answerObj = choices.filter((eachChoice:Choice)=> eachChoice.choiceid === event.target.value) as Choice[]
  
      setSelectedAnswer([{
        "choice":  answerObj[0].choice,
        "choiceid": event.target.value
      }]);
    };
  
    const handleFileChange = (event:any) => {
     // setFile(event.target.files[0]);
    };
  
    return (
      <FormControl component="fieldset" fullWidth={true}>
        <RadioGroup
          aria-label=""
          name="yes_no"
          value={selectedValue}
          key={selectedValue}
          ref={radioInputRef}
          onChange={handleRadioChange}
        >
          {choices.map((option: any) => (<FormControlLabel key={option.choiceid} value={option.choiceid} control={<Radio />} label={option.choice} />))}
         
        </RadioGroup>
        <FormLabel component="legend">Upload images of items you want to keep</FormLabel>
  
        <TextField
          type="file"
          label=""
          variant="outlined"
          fullWidth
          onChange={handleFileChange}
        />
      </FormControl>
    );
    return (<></>)
  }

  export default ClientComponent(FileUpload);